import React, { useState } from 'react';
import styled from 'styled-components/macro';
import showdown from 'showdown';
import { getTranslation, LocaleType } from '../utils/getTranslations';
import Sentiments from '../Sentiments';
import { Typography } from '@deeptrue-frontend/ui';
import { ReactComponent as PlusIcon } from '../../../assets/icons/plus-report.svg';
import { ReactComponent as MinusIcon } from '../../../assets/icons/minus-report.svg';

const QuestionContainer = styled.div`
  width: 100%;
  border-bottom: 0.67px solid #e3e5e8;
  border-top: 0.67px solid #e3e5e8;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 3.5rem;
`;
const Question = styled(Typography)`
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  color: #253858;
  margin: 1.5rem 1rem;
`;

const StyledButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  width: 1.5rem;
  height: 1rem;
  width: 1rem;
  height: 1rem;
  margin: 0 1.5rem;
  position: absolute;
  right: 1.875rem;
`;
const AnswersContainer = styled.div`
  width: 100%;
  max-height: 13.875rem;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: clip;
  -ms-overflow-style: none;
  scrollbar-width: auto;
`;
const Answer = styled(Typography)`
  word-wrap: break-word;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #253858;
  margin: 0 1.56rem;
  border-bottom: 1px solid #e3e5e8;
  padding: 1.25rem 0;
  &:last-child {
    border-bottom: none;
  }
`;

const Circle = styled.div<{ color: string }>`
  min-width: 1.125rem;
  min-height: 1.125rem;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  margin: 0 0.5rem 0 1rem;
`;

const MarkdownWrapper = styled.span`
  p {
    margin: 0;
    word-wrap: break-word;
  }
`;

export interface OpenQuestionType {
  question: { [key: string]: string } | string;
  sentiment?: string | null;
  answers: string[];
}

interface OpenQuestionElementPropsType {
  element: OpenQuestionType;
  locale: LocaleType;
}

const OpenQuestionElement = ({
  element,
  locale,
}: OpenQuestionElementPropsType) => {
  const [isAnswerOpen, setIsAnswerOpen] = useState(false);
  const isAnyAnswerProvided = element.answers && element.answers.length > 0;

  const circleColor =
    typeof element.sentiment === 'string'
      ? Sentiments.get(parseInt(element.sentiment)).color
      : null;

  const converter = new showdown.Converter();
  const question = converter.makeHtml(getTranslation(element.question, locale));

  return (
    <>
      <QuestionContainer>
        {circleColor && <Circle color={circleColor} />}
        <Question>
          <MarkdownWrapper
            dangerouslySetInnerHTML={{
              __html: question,
            }}
          />
        </Question>
        {isAnyAnswerProvided && (
          <StyledButton onClick={() => setIsAnswerOpen(!isAnswerOpen)}>
            {isAnswerOpen ? <MinusIcon /> : <PlusIcon />}
          </StyledButton>
        )}
      </QuestionContainer>
      <AnswersContainer>
        {isAnswerOpen &&
          isAnyAnswerProvided &&
          element.answers.map((answer, idx) => {
            return <Answer key={`${answer}-${idx}`}>{answer}</Answer>;
          })}
      </AnswersContainer>
    </>
  );
};

export default OpenQuestionElement;
